// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyBD8vw4w9J9WboOKp_b72sgKXM8TvSAqis",
    authDomain: "hackaithon-eaf3d.firebaseapp.com",
    databaseURL:
        "https://hackaithon-eaf3d-default-rtdb.asia-southeast1.firebasedatabase.app",
    projectId: "hackaithon-eaf3d",
    storageBucket: "hackaithon-eaf3d.appspot.com",
    messagingSenderId: "377727826299",
    appId: "1:377727826299:web:a1e101344ed925aa53a5de",
    measurementId: "G-VW7SX2RM2G",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export const db = getFirestore();
export default analytics;
